'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import React from 'react';
import { findDOMNode } from 'react-dom';

var PregressBar = /*#__PURE__*/function (_React$Component) {
  _inherits(PregressBar, _React$Component);

  function PregressBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PregressBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PregressBar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.setScoreAndStyle = function (scorePercentage) {
      var progressBarNode = findDOMNode(_this.refs.progressBar); // Using setTimeout ensures the bar animates

      setTimeout(function () {
        // Set the width based on score
        progressBarNode.style.width = scorePercentage + "%";
      }, 1);
    };

    return _this;
  }

  _createClass(PregressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setScoreAndStyle(this.props.scorePercentage);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_jsxs("div", {
        className: "bar-wrapper",
        children: [/*#__PURE__*/_jsx("div", {
          className: "bar"
        }), /*#__PURE__*/_jsx("div", {
          className: "bar progress-bar",
          ref: "progressBar"
        })]
      });
    }
  }]);

  return PregressBar;
}(React.Component);

PregressBar.propTypes = {
  scorePercentage: PropTypes.number.isRequired
};
export { PregressBar as default };